import { defineMessages } from 'react-intl';

export default defineMessages({
    daysAgo: {
        id: 'e1p.gateway.activity.date.filter.days ago',
        defaultMessage: '{days} days ago'
    },
    escalationDate: {
        id: 'e1p.gateway.directives.activity-summary.Escalation Date',
        defaultMessage:
            'Escalation Date'
    },
    createdBy: {
        id: 'e1p.gateway.directives.activity-view-summary.Created By',
        defaultMessage:
            'Created By'
    },
    aType: {
        id: 'e1p.gateway.directives.activity-view-summary.Type',
        defaultMessage:
            'Type'
    },
    created: {
        id: 'e1p.gateway.directives.activity-view-summary.Created',
        defaultMessage:
            'Created'
    },
    description: {
        id: 'e1p.gateway.directives.activity-view-summary.Description',
        defaultMessage:
            'Description'
    },
    completed: {
        id: 'e1p.gateway.directives.activity-view-summary.COMPLETED',
        defaultMessage:
            'COMPLETED'
    },
    complete: {
        id: 'e1p.gateway.directives.activity-view-summary.Complete',
        defaultMessage:
            'Complete'
    },
    yesterday: {
        id: 'e1p.gateway.activity.date.filter.Yesterday',
        defaultMessage:
            'Yesterday'
    },
    tomorrow: {
        id: 'e1p.gateway.activity.date.filter.Tomorrow',
        defaultMessage:
            'Tomorrow'
    },
    today: {
        id: 'e1p.gateway.activity.date.filter.Today',
        defaultMessage:
            'Today'
    },
    monday: {
        id: 'e1p.gateway.activity.date.filter.Monday',
        defaultMessage:
            'Monday'
    },
    tuesday: {
        id: 'e1p.gateway.activity.date.filter.Tuesday',
        defaultMessage:
            'Tuesday'
    },
    wednesday: {
        id: 'e1p.gateway.activity.date.filter.Wednesday',
        defaultMessage:
            'Wednesday'
    },
    thursday: {
        id: 'e1p.gateway.activity.date.filter.Thursday',
        defaultMessage:
            'Thursday'
    },
    friday: {
        id: 'e1p.gateway.activity.date.filter.Friday',
        defaultMessage:
            'Friday'
    },
    saturday: {
        id: 'e1p.gateway.activity.date.filter.Saturday',
        defaultMessage:
            'Saturday'
    },
    sunday: {
        id: 'e1p.gateway.activity.date.filter.Sunday',
        defaultMessage: 'Sunday'
    },
    for: {
        id: 'e1p.gateway.activity.date.filter.For',
        defaultMessage: 'for'
    },
    followUpActivity: {
        id: 'e1p.gateway.activity.date.filter.Add Follow-up Activity',
        defaultMessage: 'Add Follow-up Activity'
    },
});
